export default __webpack_public_path__ + "static/media/admission_test_pattern.ac532551.svg";